var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',{staticClass:"atlas-setup-container"},[_c('iframe',{staticClass:"atlas-setup-iframe",attrs:{"src":_vm.atlasSetupUrl,"frameborder":"0","allow":"clipboard-read; clipboard-write"}})])
}
var staticRenderFns = []

export { render, staticRenderFns }